module.exports = __webpack_public_path__ + "img/Icon awesome-shopping-bag.54e2938c.svg";